export const DEPARTING_SOON_HOURS = 72;
export const SLA_WARNING_MINUTES = 30;
export const SLA_OVERDUE_MINUTES = 120;

export const ACTIVE_REQUEST_STATUSES = new Set([
  'open',
  'assigned',
  'in_progress',
  'awaiting_supplier',
  'awaiting_traveler'
]);

const SEVERITY_RANK = {
  critical: 0,
  urgent: 1,
  overdue: 2,
  warning: 3,
  info: 4,
  opportunity: 5
};

export function minutesSince(createdAt, now = new Date()) {
  const created = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(created.getTime())) return 0;
  return Math.max(0, Math.floor((now.getTime() - created.getTime()) / 60000));
}

export function formatRequestAge(createdAt, now = new Date()) {
  const minutes = minutesSince(createdAt, now);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `${hours} hr`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? '' : 's'}`;
}

export function requestSlaLevel(request, now = new Date()) {
  if (!request || !ACTIVE_REQUEST_STATUSES.has(request.status)) return 'normal';
  if (request.priority === 'critical' || request.priority === 'urgent') return 'urgent';
  const age = minutesSince(request.createdAt || request.created_at, now);
  if (age > SLA_OVERDUE_MINUTES) return 'overdue';
  if (age > SLA_WARNING_MINUTES) return 'warning';
  return 'normal';
}

export function attentionSeverity(request, now = new Date()) {
  if (!request) return 'info';
  if (['critical', 'urgent', 'opportunity', 'info'].includes(request.priority)) {
    return request.priority;
  }
  const sla = requestSlaLevel(request, now);
  if (sla === 'overdue') return 'overdue';
  if (sla === 'urgent') return 'urgent';
  if (sla === 'warning') return 'warning';
  return request.priority || 'warning';
}

export function compareAttentionItems(a, b) {
  const rankA = SEVERITY_RANK[a.severity] ?? 99;
  const rankB = SEVERITY_RANK[b.severity] ?? 99;
  if (rankA !== rankB) return rankA - rankB;
  return new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime();
}

export function severityLabelKey(severity) {
  return `partnerOps.severity.${severity || 'info'}`;
}
